import classNames from 'classnames';
import isEqual from 'lodash/isEqual';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import './styles.css';
import BasicButton from '../../../../../components/BasicButton';

const FiltersAccordionGroupRange = ({
    title,
    elements,
    group,
    onChange,
    selected,
    section
  }) => {
  const [valueMin, setValueMin] = useState(selected ? selected[0] : '');
  const [valueMax, setValueMax] = useState(selected ? selected[1] : '');
  const [sliderValue, setSliderValue] = useState(selected && selected.length ? [
    selected[0],
    selected[1],
  ] : []);
  const mode = useMemo(() => {
    return section.props && section.props.mode === 'input' ? 'input' : 'filter';
  }, []);
  const years = useMemo(() => {
    const list = elements
      .map(el => parseInt(el, 10));
    const marks = {};
    const realMin = Math.min(...list);
    const realMax = Math.max(...list);

    list[0] = list[1] - 1;
    list[list.length - 1] = list[list.length - 2] + 1;

    list.forEach((el, index) => {
      let label = ' ';
      const style = {};

      if (index === 0) {
        label = `Prior to ${el + 1}`;
        style.transform = 'translateX(-5px)';
      }

      if (index === list.length - 1) {
        label = `${el} and later`;
        style.transform = 'translateX(calc(-100% + 5px))';
      }

      marks[el] = {
        label,
        style
      };
    });

    return {
      min: Math.min(...list),
      max: Math.max(...list),
      realMin,
      realMax,
      list: marks,
    };
  }, [elements]);

  const handleSliderChange = useCallback((v) => {
    setSliderValue(v);

    if (v[0] === years.min) {
      v[0] = years.realMin;
    }

    if (v[1] === years.max) {
      v[1] = years.realMax;
    }

    if (valueMin > v[0] && valueMin <= years.min) {
      v[0] = valueMin;
    }

    if (valueMax < v[1] && valueMax >= years.max) {
      v[1] = valueMax;
    }

    return v;
  }, [setSliderValue, valueMin, valueMax]);

  useEffect(() => {
    setValueMin(selected ? selected[0] : '');
    setValueMax(selected ? selected[1] : '');
    setSliderValue(selected || []);
  }, [selected]);

  return (
    <div className="filter-group filter-group--range">
      {title && <span className="filter-group__title">{title}</span>}
      <div className="filter-group__form">
        <div className={'filter-range'}>
          <div className={'filter-range__fields'}>
            <input
              type="number"
              className={classNames(
                'filter-range__input',
                {
                  'filter-range__input--invalid': valueMin && (valueMin < years.realMin || valueMin > years.realMax || valueMin > valueMax),
                })
              }
              placeholder={'min'}
              value={valueMin}
              min={years.realMin}
              max={years.realMax}
              onChange={(e) => {
                const v = parseInt(e.target.value, 10);
                setValueMin(isNaN(v) ? '' : v);

                if (!isNaN(v)) {
                  setSliderValue([v, sliderValue[1]]);
                } else {
                  setSliderValue(sliderValue[1] ? [sliderValue[1]] : []);
                }

                if (mode !== 'filter') {
                  onChange(group, [v, valueMax]);
                }
              }}
            />
            <input
              type="number"
              className={classNames(
                'filter-range__input',
                {
                  'filter-range__input--invalid': valueMax && (valueMax < years.realMin || valueMax > years.realMax || valueMax < valueMin),
                })
              }
              placeholder={'max'}
              value={valueMax}
              min={years.realMin}
              max={years.realMax}
              onChange={(e) => {
                const v = parseInt(e.target.value, 10);

                setValueMax(isNaN(v) ? '' : v);

                if (!isNaN(v)) {
                  setSliderValue([sliderValue[0], v]);
                } else {
                  setSliderValue(sliderValue[0] ? [sliderValue[0]] : []);
                }

                if (mode !== 'filter') {
                  onChange(group, [valueMin, v]);
                }
              }}
            />
            {mode === 'filter' && (
              <BasicButton
                btnText={'Ok'}
                disabled={isEqual(selected, [valueMin, valueMax]) || !valueMin || !valueMax}
                controlFunc={() => {
                  if (isEqual(selected, [valueMin, valueMax]) === false) {
                    onChange(group, [valueMin, valueMax]);
                  }
                }}
                btnArrow={false}
                btnWidth={60}
              />
            )}
          </div>
          <div className={'filter-range__slider'}>
            <Slider
              range
              min={years.min}
              max={years.max}
              marks={years.list}
              step={null}
              value={sliderValue}
              onChangeComplete={v => {
                v = handleSliderChange(v);

                if (isEqual(selected, v) === false) {
                  onChange(group, v);
                }
              }}
              onChange={v => {
                v = handleSliderChange(v);
                setValueMin(v[0]);
                setValueMax(v[1]);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiltersAccordionGroupRange;
